import React, { useEffect } from 'react'
import { Link } from "react-router-dom";

import NavBar from '../Common/Navbar'
import FooterMenu from '../Common/FooterMenu';
import Copyright from '../Common/Copyright';
import TopButton from '../Home/TopButton';
import Gallery from '../Home/Gallery';

import Gallery1 from '../../assets/Images/all-gallary-1.png';
import Gallery2 from '../../assets/Images/all-gallary-2.png';
import Gallery3 from '../../assets/Images/all-gallary-3.png';
import Gallery4 from '../../assets/Images/all-gallary-4.png';
import Gallery5 from '../../assets/Images/all-gallary-5.png';
import Gallery6 from '../../assets/Images/all-gallary-6.png';
import Gallery7 from '../../assets/Images/all-gallary-7.png';
import Gallery8 from '../../assets/Images/all-gallary-8.png';
import Gallery9 from '../../assets/Images/all-gallary-9.png';
import Gallery10 from '../../assets/Images/all-gallary-10.png';
import Gallery11 from '../../assets/Images/all-gallary-11.png';

function Projects() {
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
    return (
        <>
            <div className='header-about'>
                <NavBar />
                <div className="container text-center cont-sec">
                    <h2>Our Latest Project</h2>
                    <div className="d-flex align-items-center justify-content-center">
                        <Link to = "/">Home</Link>
                        <span>//</span>
                        <Link to = "/Project">Portfolio</Link>
                    </div>
                </div>
            </div>
            <section className='gallery'>
            <div className="gall-bg"></div>
            <span></span>
            <div class="container gall-main"> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1300" */}
                <ul class="nav nav-pills mb-4 d-flex flex-wrap gap-2" id="pills-tab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="pills-photo-tab" data-bs-toggle="pill" data-bs-target="#pills-photo" type="button" role="tab" aria-controls="pills-photo" aria-selected="true">All</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-interior-tab" data-bs-toggle="pill" data-bs-target="#pills-interior" type="button" role="tab" aria-controls="pills-interior" aria-selected="false">DESIGN</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-food-tab" data-bs-toggle="pill" data-bs-target="#pills-food" type="button" role="tab" aria-controls="pills-food" aria-selected="false">DEVELOPMENT</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-events-tab" data-bs-toggle="pill" data-bs-target="#pills-events" type="button" role="tab" aria-controls="pills-events" aria-selected="false">BRANDING</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="pills-Guest-tab" data-bs-toggle="pill" data-bs-target="#pills-Guest" type="button" role="tab" aria-controls="pills-Guest" aria-selected="false">UI/UX</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="marketing-tab" data-bs-toggle="pill" data-bs-target="#marketing" type="button" role="tab" aria-controls="pills-marketing" aria-selected="false">MARKETING</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="seo-tab" data-bs-toggle="pill" data-bs-target="#seo" type="button" role="tab" aria-controls="pills-seo" aria-selected="false">SEO</button>
                    </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                    <div class="tab-pane fade show active" id="pills-photo" role="tabpanel" aria-labelledby="pills-photo-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery1} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery2} alt="gallery2.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery4} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery5} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery6} style={{ height: '200px' }} alt="gallery6.img" />
                                        </figure>
                                        <figure>
                                            <img src={Gallery7} style={{ height: '200px' }} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery9} alt="gallery9.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery10} alt="gallery10.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery11} alt="gallery11.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-interior" role="tabpanel" aria-labelledby="pills-interior-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery6} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div className="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery7} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery1} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery10} alt="gallery10.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery11} alt="gallery11.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-food" role="tabpanel" aria-labelledby="pills-food-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery4} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery5} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery6} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div className="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery9} alt="gallery9.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-events" role="tabpanel" aria-labelledby="pills-events-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery6} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="pills-Guest" role="tabpanel" aria-labelledby="pills-Guest-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery4} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="marketing" role="tabpanel" aria-labelledby="marketing-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery1} alt="gallery1.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery2} alt="gallery2.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery3} alt="gallery3.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery11} alt="gallery11.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="seo" role="tabpanel" aria-labelledby="seo-tab">
                        <div className="d-flex justify-content-center">
                            <div class="container">
                                <div class="row w-100">
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery4} alt="gallery4.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery5} alt="gallery5.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery7} alt="gallery7.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-8 p-0">
                                        <figure>
                                            <img src={Gallery6} alt="gallery6.img" />
                                        </figure>
                                    </div>
                                    <div class="col-md-4 p-0">
                                        <figure>
                                            <img src={Gallery8} alt="gallery8.img" />
                                        </figure>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gallery-hr d-flex align-items-center justify-content-end gap-3 mt-4">
                    <h6>Creative Solution</h6>
                    <hr />
                </div>
            </div>
        </section>
            <FooterMenu />
            <Copyright />
            <TopButton />
        </>
    )
}

export default Projects
